<template>
	<div class="column is-full-mobile is-half-desktop p-3 mb-4">
		<div class="medium-text mb-4">About This Assessment</div>
		<div class="mb-4">{{ quizDescription }}</div>
		<div class="passing-info has-text-primary is-radius-4 p-3">
			<div class="bold-text">
				<img src="@/assets/images/skill-assessment/icons/info.svg" style="height:16px;" class="mr-1"/> Passing Score Required
			</div>
			<div>
				You need to score {{ quizPassingScore }}% or higher to pass this assessment. Take your time and read each question carefully.
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { QuizGetters } from '@/store/modules/quiz/getters'
import { STATE_MODULES } from '@/store/state-modules'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
	computed: {
		...mapGetters(STATE_MODULES.QUIZ, {
			quizDescription: QuizGetters.GET_QUIZ_DESCRIPTION,
			quizPassingScore: QuizGetters.GET_QUIZ_PASSING_SCORE
		})
	}
})
</script>

<style scoped>
	.passing-info{
		background: #B8D8FC;
	}
</style>
